import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=26891d25"
import script from "./courseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./courseDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=26891d25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports